import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export function IntegrationCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    const llmStatus = searchParams.get('llm');
    const reason = searchParams.get('reason');

    // Read origin from sessionStorage
    const origin = sessionStorage.getItem('raios_oauth_origin') ?? 'settings';
    sessionStorage.removeItem('raios_oauth_origin');

    if (!user) {
      // Not logged in — go to login
      navigate('/login', { replace: true });
      return;
    }

    if (llmStatus === 'connected') {
      if (origin === 'onboarding') {
        navigate('/onboarding?llm=connected', { replace: true });
      } else {
        navigate('/settings?llm=connected', { replace: true });
      }
    } else if (llmStatus === 'error') {
      if (origin === 'onboarding') {
        navigate(`/onboarding?llm=error&reason=${encodeURIComponent(reason ?? 'unknown')}`, { replace: true });
      } else {
        navigate(`/settings?llm=error&reason=${encodeURIComponent(reason ?? 'unknown')}`, { replace: true });
      }
    } else {
      // Unknown state — go to settings
      navigate('/settings', { replace: true });
    }
  }, [loading, user, searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-raios-bg">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 text-raios-accent animate-spin" />
        <p className="text-sm text-raios-muted">Processando conexao...</p>
      </div>
    </div>
  );
}
